import {PropertyBase} from "./PropertyBase";

export class SearchableDropDown extends PropertyBase{
    public label:string="Custom Rows";
    public options:{label:string,value:string}[]=[];
    public multiple:boolean=false;

    protected InternalGetElement(): JQuery {

        let $select:JQuery=jQuery(`<select class="form-control"></select>`);
        if(this.multiple)
            $select.attr('multiple','multiple');
        let selectedValue=this.GetOptionValue();
        for(let option of this.options)
        {
            let $option=jQuery(new Option(option.label,option.value,selectedValue));
            if(selectedValue==option.value)
                $option.attr('selected','selected');
            $select.append($option);
        }
        $select.change(()=>this.SetOptionValue($select.val()));
        return $select;

    }


    public AddOption(label:string,value:string)
    {
        this.options.push({
            value:value,
            label:label
        });
        return this;
    }

    protected InternalGenerationCompleted($element: JQuery) {
        $element.select2();

    }

    public SetAllowMultiple(){
        this.multiple=true;
        return this;
    }

    public SubRenderer(): React.ReactNode {
        return undefined;
    }
}